import { Icon } from '@/kit/Icon';
import { DialogClose, DialogContent, type DialogComponentProps } from '@/kit/dialog';
import type { PolicyTextDialogData } from '@/core/models/report-settings.models';
import { CAPITALISATION_FALLBACK, FINANCIAL_FALLBACK } from './policyTexts';
import { sanitizeHtml } from './sanitizeHtml';

interface PolicyTextDialogProps extends DialogComponentProps<PolicyTextDialogData, boolean> {
  heading: string;
  fallback: string;
}

/**
 * The shared body of Angular's FinancialDialogComponent and CapitalisationDialogComponent (two copies of the same
 * template): shows the policy wording; Save returns true so the caller stores it for the client.
 */
function PolicyTextDialog({ data, heading, fallback }: PolicyTextDialogProps) {
  return (
    <div className="mat-dialog-wrapper">
      <DialogContent>
        <form noValidate onSubmit={(event) => event.preventDefault()}>
          <div className="main-contain">
            <div className="sidenav-header">
              <div className="d-flex align-items-center justify-space-between">
                <h2 className="m-0">
                  <span>{heading}</span>
                </h2>
                <DialogClose>
                  <Icon name="close" className="close" />
                </DialogClose>
              </div>
            </div>
          </div>
          <div>
            <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.content || fallback) }} />
          </div>
          <div className="d-flex gap-15 hr-top pt-1 mt-1">
            <DialogClose as="button" type="button" result={true} className="action-button primary-button">
              Save
            </DialogClose>
            <DialogClose as="button" type="button" className="action-button secondary-button">
              Cancel
            </DialogClose>
          </div>
        </form>
      </DialogContent>
    </div>
  );
}

/** Angular CapitalisationDialogComponent (heading has a trailing space in the source). */
export function CapitalisationDialog(props: DialogComponentProps<PolicyTextDialogData, boolean>) {
  return (
    <PolicyTextDialog {...props} heading="Capitalisation of borrowing costs " fallback={CAPITALISATION_FALLBACK} />
  );
}

/** Angular FinancialDialogComponent. */
export function FinancialDialog(props: DialogComponentProps<PolicyTextDialogData, boolean>) {
  return <PolicyTextDialog {...props} heading="Financial instrument" fallback={FINANCIAL_FALLBACK} />;
}
